import Spinner from 'src/javascripts/components/utilities/Spinner';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {noResultsTemplate, genericDisplayTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default class SurveysTablesEdit {

  constructor() {}

  render() {
    let accountUrl = $('body').attr('data-account-url');

    // Display table results
    const tableDisplayAllTemplate = (title, category, instructions, id) => 
      '<div class=\'card mb-2 clickable bg-gray100 table-search-option\' data-title=\'' + title + '\' data-table-id=\'' + id + '\'>' +
        '<div class=\'card-body p-3\'>' +
          '<div class="mb-1 font-weight-bold" style=\'font-size: 13px; font-family: Inter;\'>' + title + '</div>' +
          '<div class=\'position-absolute text-gray600\' style=\'top: 10px; right: 10px; font-size: 12px; font-family: Inter;\'>' + category + '</div>' +
          '<div class=\'text-gray500\' style=\'font-size: 12px; font-family: Inter;\'>' +
            (instructions ? instructions.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>') : '') +
          '</div>' +
        '</div>' +
      '</div>';

    // Table search
    let assetClass = $('#tables_search').data('asset-class') || '';
    let tablesBloodhound = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      remote: {
        url: '/' + accountUrl + '/surveys/tables?query=%QUERY&asset_class=' + encodeURIComponent(assetClass),
        wildcard: "%QUERY",
        cache: false
      }});
    tablesBloodhound.initialize();
    $('#tables_search').typeahead({
      hint: true,
      highlight: true,
      minLength: 0,
      classNames: {
        menu: 'd-none' // add class name to menu so default dropdown does not show
      }
    }, {
      name: 'tables',
      display: 'name',
      limit: 351,
      source: tablesBloodhound.ttAdapter(),
      menu: '#tablesSearchResults'
    });

    $('#tables_search').on('typeahead:render', function (e, datum) {
      $('#tablesSearchResults').empty();
      $('#tablesSearchResults').closest('.form-group').removeClass('d-none');
      Spinner($('#tablesSearchResults'));
      var suggestions = Array.prototype.slice.call(arguments, 1);
      if ((typeof suggestions[0] !== 'undefined') && (suggestions[0].length > 0)) {

        //empty suggestion div to display results
        for (var c = 0; c < suggestions[0].length; c++) {

          // Set template to render
          let template;
          template = tableDisplayAllTemplate(
            suggestions[0][c].name, 
            suggestions[0][c].category, 
            suggestions[0][c].instructions,
            suggestions[0][c].record_id
          );

          // Append to companies search list
          $('#tablesSearchResults').append(template);

        }

        // Remove spinner
        $('#tablesSearchResults').find('.spinner-container').remove();

      } else {

        // Append to companies search list
        $('#tablesSearchResults').find('.spinner-container').remove();
        $('#tablesSearchResults').empty().append("No table found")
        
      }

      // Update selected on click 
      $('.table-search-option').click(function(ev) {
        let qid = $(this).attr('data-table-id');
        let qText = $(this).attr('data-title');
        $('#existing_table_id').val(qid);
        $('#tables_search').val(qText);
        $('#tablesSearchResults').closest('.form-group').addClass('d-none');
      });

    });
    
    // On clear typeahead
    $('.clear-tables-typeahead').click(function() {
      $('#existing_table_id').val("");
      $('#tables_search').typeahead("val", "");
      $('#tables_search').focus();
      $('#tablesSearchResults').closest('.form-group').removeClass('d-none');
    })

    // Focus questions
    if ($('#tables_search').length !== 0) {
      $('#tables_search').focus();
    }

  }

}